<template>
   <div></div>
</template>

<script>
export default {

    mounted(){
        window.location.href='https://work.weixin.qq.com/kfid/kfc35660a6e1c5dce3d'
    }
}
</script>

<style>

</style>